export const MAFIA_CLIENT_MOBILE_PREFIX = 'MARTY-MOBILE-';
export const MAFIA_CLIENT_DESKTOP_PREFIX = 'MARTY-DESKTOP-';
export const MAFIA_CLIENT_ZPOT_PREFIX = 'MARTY-ZPOT-';
